import React, { useEffect, useState } from 'react';
import './StaticHtmlPage.css';

function StaticHtmlPage({ title, htmlPath }) {
  const [html, setHtml] = useState('');

  useEffect(() => {
    document.title = `${title} - ProCam360`;
  }, [title]);

  useEffect(() => {
    // Carga el HTML empacado por el bundler (CRA) vía fetch
    fetch(htmlPath)
      .then((res) => res.text())
      .then(setHtml)
      .catch(() => setHtml('<p>Error cargando el contenido.</p>'));
  }, [htmlPath]);

  return (
    <div className="static-page">
      <div className="static-hero">
        <div className="static-hero-content">
          <h1>{title}</h1>
          <p>Consulta la información completa a continuación</p>
        </div>
      </div>

      <div className="container">
        <div className="static-card">
          <div
            className="static-html"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </div>
    </div>
  );
}

export default StaticHtmlPage;